import React, {useEffect, useState, FC} from "react";
import {
    clearAllBodyScrollLocks,
    disableBodyScroll,
    enableBodyScroll
} from "body-scroll-lock";
import ImageGallery, {ReactImageGalleryItem} from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {Button, useMediaQuery} from "@mui/material";
import {useTranslation} from "next-i18next";
import {useTouchDetect} from "../../hooks/use-touch-detect";
import {Image} from "../image"
import tripDatabase from "../../generated/trip-database.json";
import {styled, useTheme} from "@mui/material/styles";

const StyledGalleryButton = styled(Button)(({theme}) => ({
    zIndex: 4,
    display: "inline-block",
    position: "absolute",
    color: "#fff",
    padding: 0,
    minHeight: 0,
    minWidth: 0,
    "&:focus": {
        webkitAppearance: "none",
        outline: "none"
    },
    backgroundColor: "rgba(255,255,255,0.0)",
    "&:hover": {
        backgroundColor: "rgba(255,255,255,0.3)"
        // color: theme.palette.primary.main,
    }
}))

const StyledGalleryNav = styled(StyledGalleryButton)(({theme}) => ({
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "5rem",
    [theme.breakpoints.down("sm")]: {
        fontSize: "3rem",
        "&:hover": {
            backgroundColor: "rgba(255,255,255,0.0)"
            // color: theme.palette.primary.main,
        }
    }
}))

const getPageImages = (tripId: string, imageNames: string[]): ReadonlyArray<ReactImageGalleryItem> => {
    // maintain between TripResult.js and TripDetailGallery.js
    // return []
    return imageNames.map((name) => {


        return {
            original: `/content/trips/${tripId}/img/${name}`,
            originalWidth: 1280,
            originalHeight: 853,
            originalAlt: name,

            thumbnail: `/content/trips/${tripId}/img/${name}`,
            thumbnailWidth: 120,
            thumbnailHeight: 80,
            thumbnailAlt: "",
            //   srcSet: `${entry.resized_350} 350w,
            // ${entry.resized_430} 430w,
            // ${entry.resized_540} 540w,
            // ${entry.resized_640} 640w,
            // ${entry.resized_860} 860w,
            // ${entry.resized_1040} 1040w,
            // ${entry.original} 1280w`,
            //   // the min-widths are the bootstrap breakpoints, resize at breakpoints, then measure the image with screen capture tool to get px
            sizes: "(min-width: 992px) 640px, (min-width: 768px) 540px, (min-width: 576px) 540px, 100vw",
        };
    })


};

interface GalleryProps {
    tripId: string;
    imageNames: string[];
}
export const Gallery: FC<GalleryProps> = ({tripId, imageNames}) => {


    const {t} = useTranslation();

    const galleryItems = getPageImages(tripId, imageNames)

    const isTouchDevice = useTouchDetect()

    const theme = useTheme()

    const [isFullscreen, setFullscreen] = useState(false);

    const [showNav, setShowNav] = useState(isTouchDevice);

    const [showFullscreenButton, setShowFullscreenButton] = useState(
        isTouchDevice
    );

    const [showThumbnails, setShowThumbnails] = useState(true);

    const isLandscape = useMediaQuery("(orientation: landscape)")

    const imageGalleryRef = React.useRef(null);

    useEffect(() => {
        return function cleanup() {
            clearAllBodyScrollLocks();
        };
    }, []);

    const onScreenChange = (isFull: boolean) => {

        setShowThumbnails(!isFull);
        setFullscreen(isFull);

        if (imageGalleryRef.current) {
            if (isFull) {
                disableBodyScroll(imageGalleryRef.current);
            } else {
                enableBodyScroll(imageGalleryRef.current);
            }
        }
        //gtag("event", "fullscreen_gallery_toggled");
        //window.alert(`isFullScreen? ${isFull}`)
    };

    const _onMouseOver = () => {
        setShowFullscreenButton(true);
        setShowNav(true);
    };

    const _onMouseLeave = () => {
        setShowFullscreenButton(false);
        setShowNav(true);
    };

    // const calculateStyle = () => {
    //   if (isFullscreen) {
    //     return {
    //       width: window.innerWidth,
    //       height: window.innerHeight
    //     };
    //   }
    // };

    // const onLoad = (ref: any) => {
    //     if (ref.current) {
    //         ref.current.classList.add(classes.hiResLoaded);
    //     }
    // };

    // const _renderItemOrig = (item: any) => {
    //
    //     return (
    //         <div>
    //
    //
    //             <img
    //                 src={item.thumbnail}
    //                 alt={item.originalAlt}
    //                 width="1152"
    //                 height="768"
    //                 className={classes.blurry}
    //             />
    //
    //             <img
    //                 ref={imgRef}
    //                 src={item.original}
    //                 alt={item.originalAlt}
    //                 srcSet={item.srcSet}
    //                 sizes={item.sizes}
    //                 title={item.originalTitle}
    //                 width="1152"
    //                 height="768"
    //                 className={classes.hiResLoading}
    //                 style={isFullscreen ? {position: "absolute"} : {}}
    //                 // onError={onImageError}
    //                 onLoad={() => {
    //                     onLoad(imgRef);
    //                 }}
    //             />
    //         </div>
    //     );
    // };

    const _renderItem = (item: ReactImageGalleryItem) => {

        const isFirstImage = item.original.indexOf("img/00_") > 0

        return (
            <div style={{display: "block"}}>

                <Image
                    priority={isFirstImage}
                    blurDataURL={isFirstImage ? tripDatabase[tripId as keyof typeof tripDatabase]?.firstImageBlurDataURL : undefined}
                    placeholder={isFirstImage ? "blur" : undefined}
                    sizes={item.sizes}
                    src={item.original} width={item.originalWidth} height={item.originalHeight} alt={item.originalAlt}
                    layout={"responsive"}/>

                {/*<img*/}
                {/*    ref={imgRef}*/}
                {/*    src={item.original}*/}
                {/*    alt={item.originalAlt}*/}
                {/*    srcSet={item.srcSet}*/}
                {/*    sizes={item.sizes}*/}
                {/*    title={item.originalTitle}*/}
                {/*    width="1152"*/}
                {/*    height="768"*/}
                {/*    className={classes.hiResLoading}*/}
                {/*    style={isFullscreen ? {position: "absolute"} : {}}*/}
                {/*    // onError={onImageError}*/}
                {/*    onLoad={() => {*/}
                {/*        onLoad(imgRef);*/}
                {/*    }}*/}
                {/*/>*/}
            </div>
        );
    };

    const _renderThumbInner = (item: ReactImageGalleryItem) => {

        return (
            <span className='image-gallery-thumbnail-inner'>
                <Image
                    sizes={"(min-width: 768px) 98px, (min-width: 576px) 75px, 20vw"}
                    layout={"responsive"}
                    height={item.thumbnailHeight}
                    width={item.thumbnailWidth}
                    src={item.original}
                    title={item.thumbnailTitle}
                    alt={item.thumbnailAlt}
                    className='image-gallery-thumbnail-image'
                />
      </span>
        );
    };

    return (
        <div onMouseOver={_onMouseOver} onMouseLeave={_onMouseLeave}>
            <ImageGallery
                additionalClass={isLandscape ? "custom-landscape" : undefined}
                ref={imageGalleryRef}
                items={galleryItems}
                useBrowserFullscreen={false}
                disableKeyDown={!isFullscreen}
                onScreenChange={onScreenChange}
                showFullscreenButton={showFullscreenButton}
                showPlayButton={false}
                showThumbnails={showThumbnails}
                showNav={showNav}
                thumbnailPosition='bottom'
                lazyLoad={true}
                renderItem={_renderItem}
                renderThumbInner={_renderThumbInner}
                renderLeftNav={(onClick, disabled) => {
                    return (
                        <StyledGalleryNav
                            onClick={onClick}
                            sx={{
                                left: 0,
                                height: {
                                    xs: "60px",
                                    sm: "100px"
                                }
                            }}
                            color={"inherit"}
                            variant={"text"}
                            aria-label={t("back")}
                        >
                            <KeyboardArrowLeft color={"inherit"} fontSize={"inherit"}/>
                        </StyledGalleryNav>
                    );
                }}
                renderRightNav={(onClick, disabled) => {
                    return (
                        <StyledGalleryNav
                            onClick={onClick}
                            sx={{
                                right: 0,
                                height: {
                                    xs: "60px",
                                    sm: "100px"
                                }
                            }}
                            color={"inherit"}
                            variant={"text"}
                            aria-label={t("next")}
                        >
                            <KeyboardArrowRight color={"inherit"} fontSize={"inherit"}/>
                        </StyledGalleryNav>
                    );
                }}
                renderFullscreenButton={(onClick, isFullscreen) => {
                    return (
                        <StyledGalleryButton
                            onClick={onClick}
                            sx={{
                                top: 0,
                                right: 0,
                                lineHeight: "0px",
                                fontSize: "4rem",
                                [theme.breakpoints.down("sm")]: {
                                    fontSize: "3rem",
                                    "&:hover": {
                                        backgroundColor: "rgba(255,255,255,0.0)"
                                        // color: theme.palette.primary.main,
                                    }
                                }
                            }}

                            color={"inherit"}
                            variant={"text"}
                            aria-label={"Toggle Fullscreen"}
                        >
                            {!!isFullscreen && (
                                <FullscreenExitIcon color={"inherit"} fontSize={"inherit"}/>
                            )}
                            {!isFullscreen && (
                                <FullscreenIcon color={"inherit"} fontSize={"inherit"}/>
                            )}
                        </StyledGalleryButton>
                    );
                }}
            />
        </div>
    );
}
